import Opinions from "./Opinions";
export default Opinions;
